import { isServer } from '@okapi/dom-utils';
export const useRemoteContentProps = ({ ref, widgetId, resetStyles, content, dangerousHTML, fromServerWithFallback }) => {
    const props = {
        ref,
        'data-content': widgetId
    };
    if (dangerousHTML) {
        props.dangerouslySetInnerHTML = dangerousHTML;
    }
    if (isServer() || (fromServerWithFallback && !content)) {
        props.suppressHydrationWarning = true;
    }
    if (resetStyles) {
        props.style = { all: 'initial', display: 'contents' };
    }
    return props;
};
